import { UseFormReturn } from "react-hook-form";
import { QuoteFeeType, DiscountType } from "@trnsact/trnsact-shared-types";
import { ListingForm } from "components/shared/TableListing/types";
import { ChargeType } from "../constants";

export enum ChargeAttachType {
  Equipment = "Equipment",
  Attachment = "Attachment",
  Invoice = "Invoice",
}

export interface BasePrice {
  markup: number;
  markupType: DiscountType;

  discount: number;
  discountType: DiscountType;

  salesTax: number;
  salesTaxType: DiscountType;

  total: number;
  netPrice: number;
  retailPrice: number;
  wholesalePrice: number;
}

export interface Charge extends BasePrice {
  type: QuoteFeeType;
  label: string;
  financeType: string;
  attachTo: {
    id: string;
    type: ChargeAttachType;
    description?: string;
  };
}

export interface ChargeListingContext {
  form: UseFormReturn<ListingForm<Charge>>;
  onRemoveRow: (index: number) => void;
}

export interface ChargesEquipmentDialogData {
  onOpenCreateChargeDialog: VoidFunction;
  onConfirm: (charges: Omit<Charge, "attachTo">[]) => void;
}

export interface CreateChargeDialogData {
  onConfirm: (newChargeItem: { category: ChargeType; name: string }) => void;
}
